const getPrescriberStreet = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['Address Information']) {
    const address = prescriber['Address Information'];
    if (address.Suite) {
      return `${address.Street} ${address.Suite}`;
    }
    return address.Street;
  }
  if (patient.Prescriber[0]) {
    const address = patient.Prescriber[0]['Address Information'];
    if (address.Suite) {
      return `${address.Street} ${address.Suite}`;
    }
    return address.Street;
  }
  return null;
};

export default getPrescriberStreet;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberStreet.js